// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__17X57","assignButton":"CreateEditEquipmentSchedule_assignButton__2F_QP"};